<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">智能收银</div>
        <div class="line" />
        <div class="desc">
          智能收银一体化解决方案，帮助门店提高经营管理效率，降低经营成本
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="block-c01">
      <div class="sk-block-title">
        <div class="title">智能收银一体化解决方案</div>
      </div>
      <div class="block-c01-content">
        <img src="@/assets/images/solution/cashier-pic-01.png" alt="">
      </div>
    </div>
    <div class="block-c02">
      <div class="sk-block-title">
        <div class="title">线下门店经营场景</div>
      </div>
      <div class="block-c02-content">
        <img src="@/assets/images/solution/cashier-pic-02.png" alt="">
      </div>
    </div>
    <div class="block-c01">
      <div class="sk-block-title">
        <div class="title">产品优势</div>
      </div>
      <div class="block-c02-content" style="padding: 63px 0 68px 0;">
        <img src="@/assets/images/solution/cashier-pic-03.png" alt="">
      </div>
    </div>
    <div class="block-c03">
      <div class="sk-block-title">
        <div class="title">特色服务</div>
      </div>
      <div class="block-c03-content">
        <div v-for="(item, index) in serviceList" :key="`serviceList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/cashier-service-0${index+1}.png`)" alt="">
          <div class="name" v-html="item" />
        </div>
      </div>
    </div>
    <div class="sk-flex8">
      <div class="sk-block-title">
        <div class="title">行业解决方案</div>
      </div>
      <div class="sk-flex8-icon-name">
        <div v-for="(item, index) in solutionList" :key="`solutionList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/cashier-icon-0${index+1}.png`)" alt="">
          <div class="name">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="block-c05">
      <div class="sk-block-title">
        <div class="title">支持多款硬件设备</div>
        <div class="sub-title">智能收银只出售软件，且软件适配多款市场主流硬件设备，推荐如下精选设备</div>
      </div>
      <div class="block-c05-content">
        <div v-for="(item, index) in equipmentList" :key="`equipmentList_0${index+1}`" class="item">
          <img :src="require(`@/assets/images/solution/cashier-ad-0${index+1}.png`)" alt="">
          <div class="name">{{ item }}</div>
        </div>
      </div>
    </div>
    <CarouselItem title="智能收银" />
    <ConsultForm info-sources="智能收银" title="咨询服务 立即预约" />
    <TryModal v-if="visible" :visible="visible" info-sources="智能收银" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.Cashier,
  name: 'Cashier',
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false,
      serviceList: ['海量商品库<br/>快速添加商品', '串码管理<br/>3C行业个性化需求', '粉丝分组<br/>精准营销', '挂单拉取快速结账<br/>线上订单门店提醒'],
      solutionList: ['家用电器', '农资行业', '交通出行', '酒水饮料', '家居建材', '数码3C', '餐饮行业', '快消行业'],
      equipmentList: ['SUNMI T2', 'SUNMI T2  LIT', 'SUNMI  D2', '扫码枪', '多品牌24v钱箱', '佳博票据打印机']
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  background: url("~@/assets/images/solution/cashier-banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #28DAFB;
      margin: 16px 0 31px;
    }
    .desc {
      width: 484px;
      height: 101px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
    }
    .btn-wrap {
      .btn {
        width: 200px;
        height: 58px;
        line-height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
      }
    }
  }
}
.block-c01, .block-c02 {
  background: #fff;
  overflow: hidden;
  &-content {
    width: 1220px;
    padding: 99px 0 56px;
    margin: 0 auto;
  }
}
.block-c02 {
  background: #F1F4FF;
  &-content {
    padding: 52px 0 53px;
  }
}
.block-c03 {
  background: #f9f9f9;
  &-content {
    padding: 45px 0 62px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    .item {
      width: 284px;
      text-align: center;
    }
    .name {
      color: #595961;
      font-size: 18px;
      margin-top: 22px;
    }
  }
}
.block-c05 {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  &-content {
    width: 1200px;
    margin: 0 auto;
    padding: 61px 0 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .item {
      width: 370px;
    }
    .name {
      margin: 20px 0 40px;
      color: #000;
      font-size: 16px;
    }
  }
}
</style>
